module.exports = __webpack_public_path__ + "static/media/system.77969bf7.svg";